import React from "react"
import styled from "styled-components"
import { theme } from "@/common/Mixin"
import {
  ProductCat2Names,
  ProductCategories,
  ProductNames
} from "@/common/data/Products"
import ProductCard from "./ProductCard"
import ProductHeading from "../_UI/ProductHeading"

export interface ProductCardListProps {
  type: ProductCategories
  categoryName: string
  title: string
  description?: string
}

export default function ProductCardList({
  type,
  categoryName,
  title,
  description
}: ProductCardListProps) {
  const productNames = ProductCat2Names[type]
  return (
    <LayoutWrapper className="kg-wrapper">
      <TopWrapper>
        <HeadingWrapper className="title" productNameType="primary">
          {categoryName}
        </HeadingWrapper>
        <ProductHeading as="h3" content={title} />
        {description && (
          <TextWrapper className="body">{description}</TextWrapper>
        )}
      </TopWrapper>
      <PanelWrapper>
        {productNames.map((name, index) => (
          <ProductCard
            key={name}
            productName={ProductNames[name as keyof typeof ProductNames]}
          />
        ))}
      </PanelWrapper>
    </LayoutWrapper>
  )
}

const LayoutWrapper = styled.section`
  display: flex;
  padding-top: 0vh;
  padding-bottom: 10vh;
  flex-direction: column;
  align-self: stretch;
`

// TODO(beans): 長寬比要接近
const PanelWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 22%));
  grid-gap: 32px;
  width: 100%;
  max-width: 1100px;

  @media (${theme.lg}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (${theme.sm}) {
    grid-template-columns: repeat(1, 1fr);
  }
`

interface TopWrapperProps {
  locale?: string
}

const TopWrapper = styled.span<TopWrapperProps>`
  color: ${theme.color.primary};
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  width: 100%;
  h3 {
    font-weight: 500;
  }
`

interface HeadingWrapperProps {
  productNameType?: "normal" | "primary"
}

const HeadingWrapper = styled.span<HeadingWrapperProps>`
  color: ${({ productNameType }) =>
    productNameType === "primary"
      ? theme.color.primary
      : theme.color.textContrast};
  margin-bottom: 8px;
`

const TextWrapper = styled.span`
  color: ${theme.color.textDisabled};
  margin-top: 6px;
`
